import { useEffect, useState } from "react";
import { Play, Pause } from "lucide-react";
import { SPOTS } from "./spots";

const STEP_MS = 2400;

export function HotspotImg({ src, alt, spots, className = "", imgClass = "", testid, ...r }) {
  const [on, setOn] = useState(null);
  const [playing, setPlaying] = useState(false);
  const list = SPOTS[spots] || [];
  useEffect(() => {
    if (!playing) { return undefined; }
    const t = setTimeout(() => {
      if (on === null || on < list.length - 1) { setOn(on === null ? 0 : on + 1); } else { setPlaying(false); setOn(null); }
    }, on === null ? 0 : STEP_MS);
    return () => clearTimeout(t);
  }, [playing, on, list.length]);
  const pick = (i) => { setPlaying(false); setOn(i); };
  const play = (e) => { e.stopPropagation(); e.preventDefault(); if (playing) { setPlaying(false); } else { setOn(null); setPlaying(true); } };
  return (
    <div className={`relative ${className}`} data-testid={testid} onMouseLeave={() => { if (!playing) { setOn(null); } }}>
      <img src={src} alt={alt} className={`block h-full w-full ${imgClass}`} {...r} />
      {list.map(([x, y, w, h, t, n], i) => (
        <button key={t} type="button" aria-label={`${t}: ${n}`} data-testid={`spot-${spots}-${i}`}
          onMouseEnter={() => { if (!playing) { setOn(i); } }} onFocus={() => pick(i)} onClick={() => pick(on === i ? null : i)}
          className={`absolute rounded-xl transition-[box-shadow,background-color] duration-200 ${on === i ? "bg-[#246BFD]/10 ring-2 ring-[#246BFD]" : "hover:ring-2 hover:ring-[#246BFD]/50"}`}
          style={{ left: `${x}%`, top: `${y}%`, width: `${w}%`, height: `${h}%` }} />
      ))}
      {list.length > 0 && (
        <button type="button" onClick={play} data-testid={`tour-${spots}`} aria-label={playing ? "Pause tour" : "Play guided tour"}
          className="absolute bottom-3 right-3 z-20 flex items-center gap-2 rounded-full bg-[#246BFD] px-3.5 py-2 text-xs font-medium !text-white shadow-lg shadow-blue-600/30 transition-transform hover:-translate-y-0.5">
          {playing ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}
          {playing ? `Step ${(on ?? 0) + 1} of ${list.length}` : "Play tour"}
        </button>
      )}
      {playing && <div className="absolute bottom-0 left-0 z-20 h-1 bg-[#246BFD] transition-[width] duration-500" style={{ width: `${(((on ?? 0) + 1) / list.length) * 100}%` }} data-testid={`tour-progress-${spots}`} />}
      {on !== null && (() => {
        const [x, y, w, h, t, n] = list[on];
        const below = y + h < 62;
        const left = Math.min(Math.max(x + w / 2, 18), 82);
        return (
          <div role="tooltip" data-testid={`spot-tip-${spots}`} className="pointer-events-none absolute z-10 w-56 rounded-xl border border-[#246BFD]/30 bg-white p-3 text-left shadow-xl shadow-blue-900/15"
            style={{ left: `clamp(8px, calc(${left}% - 112px), calc(100% - 232px))`, ...(below ? { top: `calc(${y + h}% + 8px)` } : { bottom: `calc(${100 - y}% + 8px)` }) }}>
            <div className="text-sm font-semibold !text-[#07111F]">{t}</div><p className="mt-1 text-xs leading-relaxed !text-[#4E5E78]">{n}</p>
          </div>
        );
      })()}
    </div>
  );
}
